import { render, staticRenderFns } from "./TheSourceWell.vue?vue&type=template&id=6bcdad82&scoped=true&"
import script from "./TheSourceWell.vue?vue&type=script&lang=js&"
export * from "./TheSourceWell.vue?vue&type=script&lang=js&"
import style0 from "./TheSourceWell.vue?vue&type=style&index=0&id=6bcdad82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bcdad82",
  null
  
)

export default component.exports